import { ref, computed } from 'vue'

const count = ref(0)
export const stickyBarMounted = computed(() => count.value > 0)

export function useStickyBar() {
  return {
    register:   () => { count.value++ },
    unregister: () => { count.value = Math.max(0, count.value - 1) },
    mounted: stickyBarMounted,
  }
}
